// extracted by mini-css-extract-plugin
module.exports = {"container":"MyBuildingTiles_container__Vp9Ei","addNewTile":"MyBuildingTiles_addNewTile__14K1i"};